module.exports = __webpack_public_path__ + "img/jiayabeng.f22f384a.png";